export default "__VITE_ASSET__BbpTQMkr__"